import { JsonViewer } from '@textea/json-viewer';

// theme details: https://github.com/chriskempson/base16/blob/main/styling.md
export const light = {
    scheme: 'Armalytix Light',
    author: 'Armalytix',
    base00: '#ffffff', // background
    base01: '#eeeef0', 
    base02: '#d8d8de', 
    base03: '#9898a6', 
    base04: '#6e6e7c', 
    base05: '#3c3c4a', 
    base06: '#272747', 
    base07: '#0d0d14', 
    base08: '#730023', 
    base09: '#730023', // constants
    base0A: '#edbd7a', 
    base0B: '#2e7d52', 
    base0C: '#2666a0', 
    base0D: '#1a4a80', 
    base0E: '#7b3b8c', 
    base0F: '#a03030'  
}

const JsonView = ({ value, 
                    rootName = false, 
                    editable = false, 
                    displayDataTypes = false, 
                    theme = light, 
                    displaySize = false }) => (
    <JsonViewer value={value}
        rootName={rootName}
        editable={editable}
        displayDataTypes={displayDataTypes}
        theme={theme}
        displaySize={displaySize}
    />);

export default JsonView;
